/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsListOrgAutoModels } from "../../funcs/llmModelsListOrgAutoModels.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$llmModelsListOrgAutoModels: ToolDefinition = {
  name: "llm-models-list-org-auto-models",
  description: `List this org's auto-model overrides

Returns every endpoint for which this org has set its own \`"auto"\` target. Endpoints not listed fall through to the operator's YAML defaults.`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await llmModelsListOrgAutoModels(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
